import http from "./HttpService";

export function getAnforderungenSearchEndpoint(betriebId, params) {
    return "/betrieb/" + betriebId + "/anforderung/auswertung" + (params ? "?" + params : "");
}

export function getAnforderungCount(messstelleId) {
    return http.get("/betrieb/" + messstelleId + "/anforderung/auswertung/count");
}

export function deleteAnforderung(anforderungID) {
    return http.delete("/anforderung/" + anforderungID);
}